import { ADT } from "pb.adt";

import type { RefundTransactionState } from "./refund-transaction";
import type { SelectTransactionState } from "./select-transaction";

export const State = ADT.define(
	{} as {
		Initialising: true;
		// transaction states
		AwaitClientRefund: {
			isoProcessingCode: string;
			refundAmount: number;
			transactionUuid: string;
		};
		AwaitAccountSelection: { onClose: () => void };
		AwaitApplicationSelection: { onClose: () => void };
		AwaitPinEntry: { onClose: () => void };
		AwaitProcessing: true;
		AwaitSignature: { onClose: () => void };
		AwaitTransaction: true;
		DisplayPaymentMessage: { onClose: () => void };
		RefundTransaction: RefundTransactionState;
		SelectTransaction: SelectTransactionState;
		SignatureSubmitted: {
			signature?: string;
			onClose: () => void;
			onApprove: () => void;
			onDecline: () => void;
		}; // response states
		Approved: {
			currency?: string;
			totalCents: number;
			onClose: () => void;
		};
		Declined: {
			title: string;
			subtitle?: string;
			message?: string;
			onRetry: () => void;
			onCancel: () => void;
		};
		ErrorDisconnected: { onClose: () => void; onRetry: () => void };
		ErrorFailedToConnectToTerminal: {
			onClose: () => void;
			onRetry: () => void;
		};
		ErrorInactivityTimeout: { onClose: () => void; onRetry: () => void };
		ErrorOperation: { onClose: () => void };
		ErrorNetwork: { onClose: () => void; onRetry: () => void };
		ErrorTerminalBusy: { onClose: () => void; onRetry: () => void };
		ErrorTransactionNotFound: { onClose: () => void };
	},
);

export const STATE_INITIAL_TIMEOUT = 15000; // 15 seconds
export const STATE_TRANSACTION_STATE_TIMEOUT = 40000; // 40 seconds

export type State = ADT.define<typeof State>;

export const TransactionStates = [
	"AwaitAccountSelection",
	"AwaitApplicationSelection",
	"AwaitClientRefund",
	"AwaitPinEntry",
	"AwaitProcessing",
	"AwaitSignature",
	"AwaitTransaction",
	"DisplayPaymentMessage",
	"SignatureSubmitted",
] satisfies ADT.Keys<State>[];

export type TransactionStates = (typeof TransactionStates)[number];

export const ResponseStates = [
	"Approved",
	"Declined",
	"ErrorDisconnected",
	"ErrorFailedToConnectToTerminal",
	"ErrorInactivityTimeout",
	"ErrorOperation",
	"ErrorNetwork",
	"ErrorTerminalBusy",
	"ErrorTransactionNotFound",
] satisfies ADT.Keys<State>[];

export type ResponseStates = (typeof ResponseStates)[number];
